import Cliploader from "react-spinners/ClipLoader";
import { RegistrationWrapper } from "./registration-wrapper";

type RegistrationPageProps = { orgColor: string };

export const RegistrationErrorPage = ({ orgColor }: RegistrationPageProps) => {
  return (
    <RegistrationWrapper orgColor={orgColor}>
      An error occured refresh page
    </RegistrationWrapper>
  );
};

export const RegistrationLoadingPage = ({
  orgColor,
}: RegistrationPageProps) => {
  return (
    <RegistrationWrapper orgColor={orgColor}>
      <div className="my-[295px] h-full w-full text-center">
        <h1 className="pb-8 text-4xl">Loading...</h1>
        <Cliploader color="text-white" size={32} />
      </div>
    </RegistrationWrapper>
  );
};
